import React from 'react';
import { Redirect, Route as ReactRoute, Switch } from '@okapi/router-react';
import { memo } from 'common/hocs/memo';
import { useErrorCode } from 'common/hooks/use-error-code';
import { Route, routes } from './routes';

export const Routes = memo(() => <NestedRoutes routesTree={routes} />);

export const NestedRoutes: React.FC<{ routesTree: Route[] | undefined }> = ({ routesTree }) => {
  const errorCode = useErrorCode();

  if (errorCode) {
    return <Redirect to={`/${errorCode}`} />;
  }

  return (
    <Switch>
      {routesTree?.map(({ routes: nestedRoutes, component: Component, path, key, strict, exact }) => (
        <ReactRoute path={path} key={key} strict={strict} exact={exact}>
          {Component ? (
            <Component>
              <NestedRoutes routesTree={nestedRoutes} />
            </Component>
          ) : (
            <NestedRoutes routesTree={nestedRoutes} />
          )}
        </ReactRoute>
      ))}
    </Switch>
  );
};
